import Reflux from 'reflux';
import http from '../../helper/ajax';

const CategoryActions = Reflux.createActions(['getBuilderData', 'publishHelper','publishTaxonomyData']);

// builder-ajax
CategoryActions.getBuilderData.preEmit = (reqData) => {

  http.post('load_request_data', reqData).end((error, res) => {
    if (res) { 
      CategoryActions.publishHelper(JSON.parse(res.text));
    }
  });
};

export default CategoryActions;



// WEBPACK FOOTER //
// ./assets/src/frontend/panel/action/categoryActions.js